import { createSelector } from 'reselect';
import { RootState, DashboardState, MetricsState, AlertsMapState } from '../model/state';
import { GaugeData, GaugeType, GeoLocationPoint, Coords, Location } from 'model';

/**
 * Direct selector to the state
 */
const selectDashboard = () => (state: RootState) => state.dashboard;

/**
 * Other specific selectors
 */
const selectDashbaordMetrics = () => createSelector(
  selectDashboard(),
  (dashboard: DashboardState) => dashboard.metrics
);

const selectDashbaordGauges = () => createSelector(
  selectDashbaordMetrics(),
  (metrics: MetricsState): Map<GaugeType, GaugeData> => {
    const map = new Map<GaugeType, GaugeData>();
    metrics.data.gauges.forEach(item => {
      map.set(item.type, item)
    });
    return map;
  }
);

const selectDashbaordIsLoading = () => createSelector(
  selectDashboard(),
  (dashboard: DashboardState) => dashboard.metrics.isLoading,
);


const selectDashbaordAlerts = () => createSelector(
  selectDashboard(),
  (dashboard: DashboardState) => dashboard.alerts
);

const selectDashbaordAlertsIsLoading = () => createSelector(
  selectDashbaordAlerts(),
  (alerts: AlertsMapState) => alerts.isLoading,
);

const selectDashbaordAlertPoints = () => createSelector(
  selectDashbaordAlerts(),
  (alerts: AlertsMapState): GeoLocationPoint<Location>[] => {
    return alerts.locations
      .filter(loc => loc.geoLocation?.coordinates)
      .map(loc => ({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [
            loc.geoLocation?.coordinates?.longitude as number,
            loc.geoLocation?.coordinates?.latitude as number,
          ]
        },
        properties: {
          cluster: false,
          address: loc.address,
          nickname: loc.nickname || loc.address,
          city: loc.city,
          state: loc.state,
          locationId: loc.id as string,
          coordinates: loc.geoLocation?.coordinates as Coords,
          pendingStats: loc.notifications?.pending || { infoCount: 0, warningCount: 0, criticalCount: 0 },
          distance: 0,
          locations: [ { id: loc.id as string, nickname: loc.nickname || loc.address } ]
        }
      }));
  }
);

export default selectDashboard;
export {
  selectDashbaordMetrics,
  selectDashbaordGauges,
  selectDashbaordIsLoading,
  selectDashbaordAlertsIsLoading,
  selectDashbaordAlertPoints,
}
